import React from 'react';
import PropTypes from 'prop-types';

/**
 * Custom ClipboardPlus icon - a clipboard with a plus sign inside.
 * Designed to match Phosphor Icons style for consistency.
 * Used for "Create Chart" related actions.
 */
const ClipboardPlus = ({ size = 24, color = 'currentColor', style, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 256 256"
    fill={color}
    style={style}
    {...props}
  >
    {/* Clipboard body */}
    <path d="M200,32H163.74a47.92,47.92,0,0,0-71.48,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Zm72,184H56V48H82.75A47.93,47.93,0,0,0,80,64v8a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V64a47.93,47.93,0,0,0-2.75-16H200Z" />
    {/* Plus sign - horizontal line */}
    <rect x="88" y="148" width="80" height="16" rx="4" />
    {/* Plus sign - vertical line */}
    <rect x="120" y="116" width="16" height="80" rx="4" />
  </svg>
);

ClipboardPlus.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  style: PropTypes.object,
};

export default ClipboardPlus;
